import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { HOUSE_SYSTEMS, type HouseSystem } from '../engine/houses';

interface Props {
  value: HouseSystem;
  onChange: (value: HouseSystem) => void;
  disabled?: boolean;
  id?: string;
}

export const HouseSystemSelector: React.FC<Props> = ({ value, onChange, disabled, id }) => {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger id={id} className="w-[160px] text-xs">
        <SelectValue placeholder="House system" />
      </SelectTrigger>
      <SelectContent>
        {HOUSE_SYSTEMS.map((sys) => (
          <SelectItem key={sys.value} value={sys.value} className="text-xs">
            {sys.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
